module.exports = __webpack_public_path__ + "img/post1.41dce078.jpg";